import { BaseCommand } from './baseCommand';
import { Product, ProductType } from '@/store/modules/product';
import store from '@/store';
import { Vector2 } from '@babylonjs/core';
import { IShader } from '../shaders/shader';
import Element from '../element';
import { HandleBacksCommand } from './handleBacksCommand';

export class CorrectProductCommand extends BaseCommand {
    private counter: number = 0;
    constructor(
        scenePreview: any,
        private callback: (correct: boolean, open: boolean) => void = () => { },
    ) {
        super(scenePreview);
    }

    public execute() {
        const params = this.getElementParams();
        if (!params) { return; }
        this.addElement(params);
    }

    public revert() {
        this.removeElements();
        this.revertCommands();
    }

    private getElementParams(): Params | null {
        const product: Product = store.getters.product;
        const halfY = 0.5 + product.shape.y / 2;
        if (product.shape.x === 4) {
            return {
                name: `ppio_${product.depth}_${product.shape.y}.gltf`,
                light: `ppio_${product.depth}_${product.shape.y}_mesh_light.jpg`,
                shader: store.getters.shaders.selectedWall,
                position: new Vector2(2.5, halfY),
                shape: new Vector2(0, product.shape.y),
            };
        }
        if (product.shape.x === 3 &&
            product.type === ProductType.CHEST_FURNITURE) {
            return {
                name: `ppio_${product.depth}_${product.shape.y}.gltf`,
                light: `ppio_${product.depth}_${product.shape.y}_mesh_light.jpg`,
                shader: store.getters.shaders.selectedWall,
                position: new Vector2(1.5, halfY),
                shape: new Vector2(0, product.shape.y),
            };
        }
        if (product.shape.x === 3 &&
            product.type === ProductType.DESK) {
            return {
                name: `b_ppio.gltf`,
                light: `b_ppio_light.jpg`,
                shader: store.getters.shaders.selectedWall,
                position: new Vector2(1.5, halfY),
                shape: new Vector2(0, 1),
            };
        }
        return null;
    }

    private addElement(params: Params) {
        this.scenePreview.addElement(
            params.name,
            params.light,
            params.shader,
            params.position,
            params.shape,
            (x: Element) => {
                this.elements.push(x);
                this.handleBacks();
                this.callback(false, this.counter++ === 0);
            },
        );
    }

    private handleBacks() {
        const command = new HandleBacksCommand(this.scenePreview);
        this.addCommand(command);
    }
}


// tslint:disable-next-line:max-classes-per-file
interface Params {
    name: string;
    light: string;
    shader: IShader;
    position: Vector2;
    shape: Vector2;
}
